import { h } from "preact";

import { classNames, displayMoney } from "../helpers";
import RedactedInfo from "./RedactedInfo.jsx";

export default function CompensationRange({ previewMode, range, ...props }) {
  if (previewMode) {
    return (
      <span
        class={classNames(
          previewMode && "compensation-range--preview",
          props.class
        )}
      >
        <RedactedInfo w128 />
      </span>
    );
  }

  const [min, max] = range;
  if (max > 150000) {
    return (
      <span class={classNames("color-brand-jade", props.class)}>
        ≥ {displayMoney(min, "EUR", 0)}
      </span>
    );
  }
  return (
    <span class={classNames("color-brand-jade", props.class)}>
      {displayMoney(min, "EUR", 0)} - {displayMoney(max, "EUR", 0)}
    </span>
  );
}
